import script from "./base-text-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-text-editor.vue?vue&type=script&setup=true&lang=ts"

import "./base-text-editor.vue?vue&type=style&index=0&id=0293d812&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0293d812"]])

export default __exports__